import { useEffect, useState } from "react";
import client from "../../../../api/client";

export const STATUS = { ok: ["ok", "On track"], watch: ["watch", "Watch"], risk: ["risk", "At risk"] };
const KEY = "e1x-staff-scope";
const hue = (id) => (id * 47) % 360;

export const Pill = ({ cls, children }) => <span className={`sp-pill ${cls}`}>{children}</span>;

export function Avatar({ s }) {
  const initials = s.name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();
  return <span className="sp-av" style={{ background: `hsl(${hue(s.id)} 42% 38%)` }}>{s.avatar ? <img src={s.avatar} alt="" /> : initials}</span>;
}

/** A score bar with the 70% certificate mark; red under the mark. */
export function Bar({ value, label = true }) {
  if (value == null) return <span className="course-tag">No scores yet</span>;
  return (
    <div className="sp-bar">
      {label && <div className="t"><b>{value}%</b></div>}
      <div className={`sp-track ${value < 70 ? "lo" : ""}`}><i className="sc" style={{ width: `${Math.min(100, value)}%` }} /><i className="pass" /></div>
    </div>
  );
}

/** The cohort-courses this person can see (/staff/scopes), with the last one picked remembered. */
export function useScopes() {
  const [scopes, setScopes] = useState(null);
  const [scope, setScopeState] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    client.get("/staff/scopes").then((r) => {
      const list = r.data?.scopes || [];
      setScopes(list);
      let saved = null;
      try { saved = JSON.parse(localStorage.getItem(KEY) || "null"); } catch { /* storage blocked */ }
      setScopeState(list.find((s) => saved && s.cohort_id === saved.cohort_id && s.course_id === saved.course_id) || list.find((s) => s.students > 0) || list[0] || null);
    }).catch(() => setFailed(true));
  }, []);

  const setScope = (s) => {
    setScopeState(s);
    if (s.all) return; // "All courses" isn't remembered: other staff pages need one course
    try { localStorage.setItem(KEY, JSON.stringify({ cohort_id: s.cohort_id, course_id: s.course_id })); } catch { /* storage blocked */ }
  };
  return { scopes, scope, setScope, failed };
}

/** allowAll: each cohort with 2+ courses also gets "All courses" (scope.all = true, course_id = null). */
export function ScopePicker({ scopes, scope, setScope, allowAll = false }) {
  if (!scopes || (scopes.length < 2 && !allowAll)) return null;
  const val = scope ? `${scope.cohort_id}:${scope.all ? "all" : scope.course_id}` : "";
  const label = (s) => `${s.cohort.startsWith(s.course) ? s.cohort : `${s.course} · ${s.cohort}`} · ${s.students} student${s.students === 1 ? "" : "s"}`;
  const groups = [];
  scopes.forEach((s) => { const g = groups.find((x) => x.id === s.cohort_id); g ? g.items.push(s) : groups.push({ id: s.cohort_id, name: s.cohort, items: [s] }); });
  const pick = (v) => {
    const [cohortId, course] = v.split(":");
    if (course === "all") {
      const g = groups.find((x) => String(x.id) === cohortId);
      setScope({ cohort_id: g.id, course_id: null, all: true, cohort: g.name, course: "All courses", students: g.items.reduce((n, s) => n + s.students, 0) });
    } else setScope(scopes.find((s) => `${s.cohort_id}:${s.course_id}` === v));
  };
  return (
    <label className="sp-field" htmlFor="sp-scope">Course
      <select id="sp-scope" value={val} onChange={(e) => pick(e.target.value)}>
        {allowAll ? groups.map((g) => (
          <optgroup key={g.id} label={g.name}>
            {g.items.length > 1 && <option value={`${g.id}:all`}>All courses in {g.name}</option>}
            {g.items.map((s) => <option key={`${s.cohort_id}:${s.course_id}`} value={`${s.cohort_id}:${s.course_id}`}>{label(s)}</option>)}
          </optgroup>
        )) : scopes.map((s) => <option key={`${s.cohort_id}:${s.course_id}`} value={`${s.cohort_id}:${s.course_id}`}>{label(s)}</option>)}
      </select>
    </label>
  );
}
